<template>
  <v-row class="content">
    <v-col cols="12" class="d-flex justify-center">
      <template>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th v-for="head in objIncludes" :key="head" class="text-left">
                  {{ traducirHead(head) }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td v-for="item in dataSelected" :key="item" class="text-left">
                  {{ item }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </template>
    </v-col>
    <v-col
      cols="12"
      class="d-flex justify-center flex-wrap"
      style="height: 100%;"
    >
      <h3 v-if="imgSelected.length <= 0">
        No hay imágenes de este vehículo
      </h3>

      <div v-else v-for="img in imgSelected" :key="img.id" class="d-flex">
        <v-img
          :src="img.image"
          :lazy-src="img.image"
          aspect-ratio="1"
          max-height="350"
          max-width="350"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ["data"],
  data: () => ({
    objIncludes: [
      "name",
      "last_name_1",
      "last_name_2",
      "phone",
      "interesado",
      "entrega",
      "brand",
      "model",
      "plate",
      "year",
      "color",
      "kilometers",
      "notes"
    ]
  }),
  methods: {
    traducirHead(el) {
      let ret;
      switch (el) {
        case "name":
          ret = "NOMBRE";
          break;
        case "last_name_1":
          ret = "APELLIDO";
          break;
        case "last_name_2":
          ret = "APELLIDO 2";
          break;
        case "phone":
          ret = "TELÉFONO";
          break;
        case "interesado":
          ret = "V.INTERESADO";
          break;
        case "entrega":
          ret = "ENTREGA INMEDIATA";
          break;
        case "brand":
          ret = "MARCA";
          break;
        case "model":
          ret = "MODELO";
          break;
        case "plate":
          ret = "MATRÍCULA";
          break;
        case "year":
          ret = "AÑO";
          break;
        case "color":
          ret = "COLOR";
          break;
        case "kilometers":
          ret = "KILÓMETROS";
          break;
        case "notes":
          ret = "OBSERVACIONES";
          break;

        default:
          ret = el;
          break;
      }

      return ret;
    }
  },
  computed: {
    dataSelected() {
      let obj = this.data.selected;
      const filteredObj = Object.keys(obj)
        .filter(key => this.objIncludes.includes(key))
        .reduce((acc, key) => {
          acc[key] = obj[key];
          return acc;
        }, {});

      return filteredObj;
    },
    imgSelected() {
      return this.data.images;
    }
  }
};
</script>

<style scoped>
.v-simple-table thead th,
.v-simple-table tbody td {
  text-align: left;
  white-space: nowrap;
}
.v-simple-table__overflow {
  overflow-x: auto;
}
</style>
